<template>
  <div
    class="flex flex-row gap-2 px-3 py-3 text_color items-center w-full"
    :style="{ justifyContent: 'start' }"
  >
    <ProfileIcon :data="contactData" :size="28" :font="10" />
    <div class="overflow-x">
      <span class="text-sm break-all line-clamp-2">
        {{ props.value || "-" }}
      </span>
    </div>
  </div>
</template>
<script setup>
import { defineProps, computed } from "vue";
import ProfileIcon from "@/src/components/ProfileIcon.vue";

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  row: {
    type: Object,
    default: () => ({}),
  },
});

const contactData = computed(() => ({
  name: props.value || "",
  email: props.row.linkedin_url || "",
}));
</script>
